import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DeathDetails } from '../../Models/Models/Customer/DeathDetails';

declare var IS_RUNNING_IN_APP_POOL;

export class DeathDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<DeathDetails, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/DeathDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<DeathDetails, any>(url, data);
  }
  public put(customerId: number, deathDetails: DeathDetails): Promise<DeathDetails, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/DeathDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, deathDetails: deathDetails }

    return AjaxWrapper.put<DeathDetails, any>(url, data);
  }
}

